import {
  ScrollToTop,
  ThemeProvider,
  ErrorBoundary,
  CookieProvider,
  CookieConsent,
  useCookieConsent,
} from '@xanectech/components/shared';

import { Toaster, TooltipProvider } from '@xanectech/ui/components';

import { AuthProvider, RoleProvider } from '@xanectech/auth';

import { BrowserRouter, useLocation } from 'react-router-dom';
import { AboutLogger } from '@xanectech/data';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { isFeatureEnabled } from '@xanectech/lib';

import { CompanyRoutes } from './AppRoutes';

const ScrollToTopHelper = () => {
  useLocation();
  return <ScrollToTop />;
};

/**
 * Conditionally renders Vercel Analytics and Speed Insights based on analytics
 * consent. Uses the consent context so re-renders automatically when consent changes.
 */
const AnalyticsGuard = () => {
  const { checkCategory } = useCookieConsent();
  if (!checkCategory('analytics')) return null;
  return (
    <>
      <Analytics />
      <SpeedInsights />
    </>
  );
};

const App = () => {
  // const helpdexUrl: string =
  //   (import.meta.env.VITE_HELPDEX_URL as string) ??
  //   'https://helpdex.xanectech.com';
  // const isHelpIntegrationEnabled = isFeatureEnabled(
  //   'COMPANY_HELPDESK_INTEGRATION',
  // );

  return (
    <ThemeProvider defaultTheme='light' storageKey='xanectech-company-theme'>
      <CookieProvider appName='company'>
        <ErrorBoundary>
          <TooltipProvider delayDuration={500} skipDelayDuration={200}>
            <Toaster />
            <CookieConsent />
            <AnalyticsGuard />
            <AuthProvider>
              <RoleProvider>
                <BrowserRouter>
                  {/* {isHelpIntegrationEnabled ? (
                    <HelpProvider app='company' helpdexUrl={helpdexUrl}>
                      <ScrollToTopHelper />
                      <AboutLogger appName='Company Portal' />

                      <CompanyRoutes />
                      <HelpWidget />
                    </HelpProvider>
                  ) : ( */}
                  <>
                    <ScrollToTopHelper />
                    <AboutLogger appName='Company Portal' />

                    <CompanyRoutes />
                  </>
                  {/* )} */}
                </BrowserRouter>
              </RoleProvider>
            </AuthProvider>
          </TooltipProvider>
        </ErrorBoundary>
      </CookieProvider>
    </ThemeProvider>
  );
};

export default App;
